export interface SpyBrand {
  id: number;
  name: string;
  ad_library_url: string;
  category: string;
  country: string;
  is_active: boolean;
  last_scraped_at: string | null;
  created_at: string;
  ad_count: number;
  bookmark_count: number;
}

export interface AiAnalysis {
  asset_type: string;
  visual_format: string;
  messaging_angle: string;
  hook_tactic: string;
  offer_type: string;
  summary: string;
  score: number;
  improvements: string;
}

export interface SpyAd {
  id: number;
  brand_id: number;
  library_id: string;
  ad_archive_id: string;
  image_url: string | null;
  video_url: string | null;
  thumbnail_url: string | null;
  media_type: "Video" | "Image";
  headline: string;
  ad_copy: string;
  cta_text: string;
  landing_page_url: string;
  platforms: string;
  start_date: string;
  end_date: string;
  impression_rank: number;
  ai_analysis: AiAnalysis | string | null;
  is_bookmarked: boolean;
  brand_name: string;
  country: string;
  page_id: string | null;
  scraped_at: string;
}

export interface AdsFiltersData {
  asset_type: string[];
  visual_format: string[];
  messaging_angle: string[];
  hook_tactic: string[];
  offer_type: string[];
}

export interface AdsPagination {
  page: number;
  limit: number;
  total: number;
  total_pages: number;
}

export interface ScrapeStats {
  inserted: number;
  duplicates: number;
  filtered: number;
  errors: number;
  total: number;
}

export interface AdsQueryParams {
  page?: number;
  limit?: number;
  sort?: "rank" | "newest" | "oldest";
  brand_id?: string;
  media_type?: string;
  bookmarked?: string;
  unanalyzed?: string;
  asset_type?: string;
  visual_format?: string;
  messaging_angle?: string;
  hook_tactic?: string;
  offer_type?: string;
}

export interface CreateBrandPayload {
  name: string;
  ad_library_url: string;
  category: string;
}

export interface UpdateBrandPayload {
  name?: string;
  ad_library_url?: string;
  category?: string;
  is_active?: boolean;
}

export type SpyTab = "ads" | "brands" | "bookmarks";

export const SCRAPE_STATUS = {
  IDLE: "idle",
  SCRAPING: "scraping",
  COMPLETED: "completed",
  FAILED: "failed",
} as const;

export type ScrapeStatus = (typeof SCRAPE_STATUS)[keyof typeof SCRAPE_STATUS];

export const BRAND_CATEGORIES = [
  "General",
  "Salud & Bienestar",
  "Moda & Ropa",
  "Belleza & Skincare",
  "Comida & Bebidas",
  "Tech & SaaS",
  "Fitness",
  "Hogar",
  "Finanzas",
  "Educacion",
  "E-commerce",
] as const;
